<template>
  <div id="app">
    <router-view />
    <axios-res></axios-res>
  </div>
</template>

<script>
export default {
  provide() {
    return {
      reload: this.reload,

    };
  },
  created() {
    //this.ttt();
    return;
    var vmap = this.getUrlKey("vmap");

    var tt = document.getElementById('vmap');
    var html;
    if (vmap == 1.4) {
      localStorage.setItem('vmap', 1.4);
      var sr1 = document.createElement('script');
      sr1.src = "https://webapi.amap.com/maps?v=1.4.15&key=7588debd8328f138fd571bf309cae2ec&plugin=AMap.Geocoder,AMap.PolyEditor,AMap.MouseTool,AMap.Autocomplete,AMap.PlaceSearch,Map3D,AMap.DistrictSearch,AMap.GraspRoad";
      var sr2 = document.createElement('script');
      sr2.src = "https://webapi.amap.com/ui/1.0/main.js?v=1.0.11"
    } else {
      localStorage.setItem('vmap', 2.0);
      var sr1 = document.createElement('script');
      sr1.src = "https://webapi.amap.com/maps?v=2.0&key=7588debd8328f138fd571bf309cae2ec&plugin=AMap.Geocoder,AMap.PolylineEditor,AMap.PolygonEditor,AMap.MouseTool,AMap.Autocomplete,AMap.PlaceSearch,Map3D,AMap.DistrictSearch,AMap.GraspRoad"

      var sr2 = document.createElement('script');
      sr2.src = "https://webapi.amap.com/ui/1.1/main.js?v=1.0.11";
    }
    tt.appendChild(sr1);
    tt.appendChild(sr2);

  },
  methods: {
    watchWindowSize() {
      this.$store.state.isFullScreen = !this.$store.state.isFullScreen;
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    ttt() {
      var vmap = getUrlKey("vmap");

      var tt = document.getElementById('vmap');

      if (vmap == 2.0) {
        localStorage.setItem('vmap', 2.0);
        var url = "https://webapi.amap.com/maps?v=2.0&key=7588debd8328f138fd571bf309cae2ec&plugin=AMap.Geocoder,AMap.PolylineEditor,AMap.PolygonEditor,AMap.MouseTool,AMap.Autocomplete,AMap.PlaceSearch,Map3D,AMap.DistrictSearch,AMap.GraspRoad"
        var jsapi = document.createElement('script');
        jsapi.src = url;


        var sr2 = document.createElement('script');
        sr2.src = "https://webapi.amap.com/ui/1.1/main.js?v=1.0.11";

      } else {
        localStorage.setItem('vmap', 1.4);
        var url = "https://webapi.amap.com/maps?v=1.4.15&key=7588debd8328f138fd571bf309cae2ec&plugin=AMap.Geocoder,AMap.PolyEditor,AMap.MouseTool,AMap.Autocomplete,AMap.PlaceSearch,Map3D,AMap.DistrictSearch,AMap.GraspRoad";
        var jsapi = document.createElement('script');
        jsapi.src = url;
        var sr2 = document.createElement('script');
        sr2.src = "https://webapi.amap.com/ui/1.0/main.js?v=1.0.11"
      }
      document.head.appendChild(jsapi);
      document.head.appendChild(sr2);
    }
  },
  mounted() {
    window.addEventListener("resize", this.watchWindowSize);
  },
}
</script>



// WEBPACK FOOTER //
// src/App.vue